import clsx from 'clsx'
import type { ReactNode } from 'react'
import { Modal } from '~/components/Global/Design/Modal/Modal'
import { inner as innerModalStyle } from '~/components/Global/Design/Modal/Modal.css'
import { CloseTrigger } from '~/components/Global/Interactions/CloseTrigger/CloseTrigger'
import { AsideActionWrapper } from '~/components/Layout/AsideActionWrapper/AsideActionWrapper'
import {
  applicantInnerModal,
  dualWrapper
} from '~/components/Scopes/Applicants/ApplicantModal/ApplicantModal.css'
import { themeClass } from '~/styles/theme.css'

export const ApplicantModalLayout = ({
  onClose,
  children
}: {
  onClose: () => void
  children: ReactNode
}) => (
  <Modal onClose={onClose} open={true}>
    <div className={clsx(themeClass, dualWrapper)}>
      <div className={clsx(innerModalStyle, applicantInnerModal)}>
        <CloseTrigger onClose={onClose} />
        {children}
      </div>
      <AsideActionWrapper position="modal" />
    </div>
  </Modal>
)
